export default "__VITE_ASSET__DvLPH2lP__"